window.shareProduct = function () {
    if (customElements.get('share-button')) return;

    class ShareButton extends HTMLElement {
        constructor() {
            super();

            this.elements = {
                shareButton: this.querySelector(
                    '.share-button__button'
                ),
                successMessage: this.querySelector(
                    '[id^="ShareMessage"]'
                ),
                urlInput: this.querySelector('input'),
                content: this.querySelector(
                    '.share-button__fallback'
                ),
                copyButton: this.querySelector(
                    '.button-copy'
                ),
                closeButton: this.querySelector(
                    '.share-button__close'
                ),
                socialShare: this.querySelector(
                    '.social-share'
                ),
                overlay: document.querySelector(
                    '.background-overlay'
                )
            };

            if (
                !this.elements.shareButton ||
                !this.elements.urlInput ||
                !this.elements.content
            ) {
                return;
            }

            this.originalParent =
                this.elements.content.parentNode;

            this.originalNextSibling =
                this.elements.content.nextSibling;

            this.elements.shareButton.addEventListener(
                'click',
                this.toggleDetails.bind(this)
            );

            if (this.elements.copyButton) {
                this.elements.copyButton.addEventListener(
                    'click',
                    this.copyToClipboard.bind(this)
                );
            }

            if (this.elements.closeButton) {
                this.elements.closeButton.addEventListener(
                    'click',
                    this.closeDetails.bind(this)
                );
            }

            if (this.elements.overlay) {
                this.elements.overlay.addEventListener(
                    'click',
                    this.closeDetails.bind(this)
                );
            }
        }

        getOriginalUrl() {
            const productPath =
                this.elements.urlInput.getAttribute(
                    'data-product-path'
                );

            if (productPath) {
                try {
                    return new URL(
                        productPath,
                        window.location.origin
                    ).href;
                } catch (error) {
                    // Continue to the other URL sources.
                }
            }

            const dataUrl =
                this.elements.urlInput.getAttribute(
                    'data-url'
                );

            if (dataUrl) {
                try {
                    return new URL(
                        dataUrl,
                        window.location.origin
                    ).href;
                } catch (error) {
                    // Continue to the current page URL.
                }
            }

            return window.location.href;
        }

        getPartnerShareUrl() {
            const originalUrl = this.getOriginalUrl();

            if (
                window.BestyPopStore &&
                typeof window.BestyPopStore
                    .buildProductShareUrl === 'function'
            ) {
                try {
                    return window.BestyPopStore
                        .buildProductShareUrl(originalUrl);
                } catch (error) {
                    console.warn(
                        'Could not create partner share URL.',
                        error
                    );
                }
            }

            return originalUrl;
        }

        getNeutralShareText() {
            return 'Take a look at this product:';
        }

        getShareImage() {
            const imageLink =
                this.elements.socialShare?.querySelector(
                    '[data-share-image]'
                );

            return (
                imageLink?.getAttribute(
                    'data-share-image'
                ) || ''
            );
        }

        updateSocialShareLinks(shareUrl) {
            if (!this.elements.socialShare) return;

            const neutralText =
                this.getNeutralShareText();

            const imageUrl =
                this.getShareImage();

            const links =
                this.elements.socialShare.querySelectorAll(
                    '[data-share-network]'
                );

            links.forEach((link) => {
                const network =
                    link.getAttribute(
                        'data-share-network'
                    );

                let destination = '';

                switch (network) {
                    case 'facebook':
                        destination =
                            'https://www.facebook.com/' +
                            'sharer/sharer.php?u=' +
                            encodeURIComponent(shareUrl);
                        break;

                    case 'twitter':
                        destination =
                            'https://twitter.com/' +
                            'intent/tweet?text=' +
                            encodeURIComponent(
                                neutralText
                            ) +
                            '&url=' +
                            encodeURIComponent(
                                shareUrl
                            );
                        break;

                    case 'pinterest':
                        destination =
                            'https://pinterest.com/' +
                            'pin/create/button/?url=' +
                            encodeURIComponent(
                                shareUrl
                            );

                        if (imageUrl) {
                            destination +=
                                '&media=' +
                                encodeURIComponent(
                                    imageUrl
                                );
                        }

                        destination +=
                            '&description=' +
                            encodeURIComponent(
                                neutralText
                            );
                        break;

                    case 'tumblr':
                        destination =
                            'https://www.tumblr.com/' +
                            'widgets/share/tool?' +
                            'canonicalUrl=' +
                            encodeURIComponent(
                                shareUrl
                            );
                        break;

                    case 'telegram':
                        destination =
                            'https://t.me/share/url?url=' +
                            encodeURIComponent(
                                shareUrl
                            ) +
                            '&text=' +
                            encodeURIComponent(
                                neutralText
                            );
                        break;

                    case 'email':
                        destination =
                            'mailto:?subject=' +
                            encodeURIComponent(
                                neutralText
                            ) +
                            '&body=' +
                            encodeURIComponent(
                                neutralText +
                                '\n\n' +
                                shareUrl
                            );
                        break;

                    case 'whatsapp':
                        destination =
                            'https://wa.me/?text=' +
                            encodeURIComponent(
                                neutralText +
                                '\n\n' +
                                shareUrl
                            );
                        break;

                    default:
                        return;
                }

                link.setAttribute(
                    'href',
                    destination
                );
            });

            this.elements.socialShare.setAttribute(
                'data-share-url',
                shareUrl
            );
        }

        prepareShareContent() {
            const shareUrl =
                this.getPartnerShareUrl();

            this.elements.urlInput.value =
                shareUrl;

            this.elements.urlInput.setAttribute(
                'data-current-share-url',
                shareUrl
            );

            this.elements.urlInput.classList.remove(
                'is-copy'
            );

            this.updateSocialShareLinks(
                shareUrl
            );

            return shareUrl;
        }

        toggleDetails(event) {
            event.preventDefault();
            event.stopPropagation();

            const isOpen =
                this.elements.content.classList.contains(
                    'is-open'
                );

            if (isOpen) {
                this.closeDetails(event);
                return;
            }

            if (this.elements.successMessage) {
                this.elements.successMessage.classList.add(
                    'hidden'
                );

                this.elements.successMessage.setAttribute(
                    'aria-hidden',
                    'true'
                );
            }

            this.prepareShareContent();

            /*
             * Move the popup directly under body so it stays
             * above the dark page overlay.
             */
            if (
                !this.elements.content.classList.contains(
                    'share-portal'
                )
            ) {
                document.body.appendChild(
                    this.elements.content
                );

                this.elements.content.classList.add(
                    'share-portal'
                );
            }

            this.elements.content.classList.add(
                'is-open'
            );

            document.body.classList.add(
                'modal-share-open'
            );

            this.setProductInfoTop(
                this.getProductInfoPosition()
            );
        }

        async copyToClipboard(event) {
            event.preventDefault();
            event.stopPropagation();

            if (
                this.elements.urlInput.classList.contains(
                    'is-copy'
                )
            ) {
                return;
            }

            const shareUrl =
                this.elements.urlInput.getAttribute(
                    'data-current-share-url'
                ) ||
                this.prepareShareContent();

            try {
                await navigator.clipboard.writeText(
                    shareUrl
                );

                this.showCopiedMessage();
            } catch (error) {
                this.fallbackCopy(
                    shareUrl
                );
            }
        }

        fallbackCopy(text) {
            const textarea =
                document.createElement(
                    'textarea'
                );

            textarea.value = text;
            textarea.setAttribute(
                'readonly',
                ''
            );

            textarea.style.position =
                'fixed';

            textarea.style.left =
                '-9999px';

            textarea.style.top =
                '0';

            document.body.appendChild(
                textarea
            );

            textarea.focus();
            textarea.select();

            try {
                document.execCommand(
                    'copy'
                );

                this.showCopiedMessage();
            } catch (error) {
                this.elements.urlInput.focus();
                this.elements.urlInput.select();
            }

            textarea.remove();
        }

        showCopiedMessage() {
            if (this.elements.successMessage) {
                this.elements.successMessage.classList.remove(
                    'hidden'
                );

                this.elements.successMessage.setAttribute(
                    'aria-hidden',
                    'false'
                );
            }

            this.elements.urlInput.value =
                'Link copied to clipboard!';

            this.elements.urlInput.classList.add(
                'is-copy'
            );

            setTimeout(() => {
                if (
                    this.elements.successMessage
                ) {
                    this.elements.successMessage.classList.add(
                        'hidden'
                    );

                    this.elements.successMessage.setAttribute(
                        'aria-hidden',
                        'true'
                    );
                }
            }, 3000);
        }

        closeDetails(event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (
                this.elements.successMessage
            ) {
                this.elements.successMessage.classList.add(
                    'hidden'
                );

                this.elements.successMessage.setAttribute(
                    'aria-hidden',
                    'true'
                );
            }

            this.elements.urlInput.classList.remove(
                'is-copy'
            );

            this.prepareShareContent();

            this.elements.content.classList.remove(
                'is-open'
            );

            document.body.classList.remove(
                'modal-share-open'
            );

            this.setProductInfoTop(0);
        }

        getProductInfoPosition() {
            const stickyElement =
                document.querySelector(
                    '.productView-details'
                );

            if (
                !stickyElement ||
                !stickyElement.parentNode
            ) {
                return 0;
            }

            const parentElement =
                stickyElement.parentNode;

            const stickyRect =
                stickyElement.getBoundingClientRect();

            const parentRect =
                parentElement.getBoundingClientRect();

            return (
                stickyRect.top -
                parentRect.top
            );
        }

        setProductInfoTop(top) {
            const productDetails =
                document.querySelector(
                    '.productView-details'
                );

            if (productDetails) {
                productDetails.style.setProperty(
                    '--sticky-top',
                    `${top || 0}px`
                );
            }
        }
    }

    customElements.define(
        'share-button',
        ShareButton
    );
};

const shareShow =
    document.body.classList.contains(
        'quick-view-show'
    );

const productShare =
    document.querySelectorAll(
        '.halo-productView .productView-share'
    ).length;

if (
    document.body.classList.contains(
        'template-product'
    )
) {
    if (
        (!shareShow && productShare) ||
        (shareShow && productShare === 0)
    ) {
        window.shareProduct();
    }
} else {
    window.shareProduct();
}